const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 752.362h200v300H0z",
    style: {
      fill: "#169b62",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "translate(0 -752.362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 752.362h200v300H200z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "translate(0 -752.362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 752.362h200v300H400z",
    style: {
      fill: "#ff883e",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "translate(0 -752.362)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIe);
export default __webpack_public_path__ + "static/media/ie.977ecdbe389836139ba8ba19f07d15cb.svg";
export { ForwardRef as ReactComponent };